export default "__VITE_ASSET__DQ8LvQKV__"